import { render, staticRenderFns } from "./ForoCategoria.vue?vue&type=template&id=7f6bfe3e&scoped=true"
import script from "./ForoCategoria.vue?vue&type=script&lang=js"
export * from "./ForoCategoria.vue?vue&type=script&lang=js"
import style0 from "./ForoCategoria.vue?vue&type=style&index=0&id=7f6bfe3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6bfe3e",
  null
  
)

export default component.exports